"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = exports.moveTo = exports.create = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(x, y, toSay, layer) {
    // underPerf.recordCreate('floating-text')
    if (layer === void 0) { layer = null; }
    var id = -1; // createId()
    if (!layer) {
        layer = voyageLayers_sidecar_1.voyageLayers.getLayers().uiOnCam;
    }
    var text = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, x, y, layer);
    stevieTexts2_sidecar_1.stevieTexts2.setText(text, toSay);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(text, 4);
    var obj = {
        eType: 'goat-misc',
        id: id,
        idLoaded: 0,
        isDead: false,
        text: text,
        timeSecMax: 5,
        timeSecElapsed: 0,
        x: x,
        y: y,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveTo(obj, x, y) {
    obj.x = x;
    obj.y = y;
    stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.text, x, y);
}
exports.moveTo = moveTo;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        stevieTexts2_sidecar_1.stevieTexts2.kill(c.text);
    });
}
exports.updateAll = updateAll;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDelta();
    obj.timeSecElapsed += ds;
    moveTo(obj, obj.x, obj.y - ds * 20);
    var d = obj.timeSecMax - obj.timeSecElapsed;
    if (d < 1 && d > 0) {
        stevieTexts2_sidecar_1.stevieTexts2.setAlpha(obj.text, d);
    }
    if (obj.timeSecElapsed > obj.timeSecMax) {
        obj.isDead = true;
    }
}
